import React from "react";
import "./index.sass";

import CryptoMarketCap from "./components/CryptoMarketCap/index";
import MarketCap from "./components/MarketCap/index.jsx";
import CMC from "./components/CMC/index.jsx";
import FearGreed from "./components/FearGreed/index.jsx";
import BitcoinDominance from "./components/BitcoinDominance/index.jsx";
import MarketSecondCap from "./components/MarketSecondCap/MarketSecondCap.jsx";
import AverageCrypto from "./components/AverageCrypto/index.jsx";
import { useMarketData } from "./hooks/useMarketData";
import { useTranslation } from "@helpers/translate";
import { useMarketCapHistory } from "./hooks/useMarketCapHistory";
import { useCMC20History } from "./hooks/useCMC20History";
import { useAverageCryptoRSI } from "./hooks/useAverageCryptoRSI";

const Cards = () => {
  const { __ } = useTranslation();
  const { marketData } = useMarketData();

  const {
    marketCapChartData,
    formattedMarketCap,
    formattedMarketCapChange,
    isMarketCapPositive,
    isMarketCapLoading,
  } = useMarketCapHistory();

  const {
    cmc20ChartData,
    formattedCMC20Value,
    formattedCMC20Change,
    isCMC20Positive,
    isCMC20Loading,
  } = useCMC20History();

  const {
    averageCryptoRSI,
    formattedAverageCryptoRSI,
    isAverageCryptoRSILoading,
  } = useAverageCryptoRSI();

  return (
    <div className="markets__cards">
      <ul className="markets__cards-list">
        <li>
          <CryptoMarketCap
            totalMarketCap={marketData.totalMarketCap ?? "2.64"}
            totalMarketCapChange={marketData.totalMarketCapChange ?? "2.12"}
            tradingVolume={marketData.tradingVolume ?? "191.14"}
            tradingVolumeChange={marketData.tradingVolumeChange ?? "0.00"}
            btcDominance={marketData.btcDominance ?? "60.3"}
            ethDominance={marketData.ethDominance ?? "10.8"}
            otherDominance={marketData.otherDominance ?? "28.9"}
          />
        </li>

        <li>
          <MarketCap
            title={__("markets.marketCapTitle")}
            value={formattedMarketCap}
            change={formattedMarketCapChange}
            isPositive={isMarketCapPositive}
            chartData={marketCapChartData}
            isLoading={isMarketCapLoading}
          />
        </li>

        <li>
          <CMC
            title="CMC20"
            value={formattedCMC20Value}
            change={formattedCMC20Change}
            isPositive={isCMC20Positive}
            chartData={cmc20ChartData}
            isLoading={isCMC20Loading}
          />
        </li>

        <li>
          <FearGreed
            value={marketData.fearGreedValue ?? 15}
            label={__("markets.extremeFear")}
          />
        </li>

        <li>
          <BitcoinDominance
            btcPercent={Number(marketData.btcDominance ?? 59.3)}
            ethPercent={Number(marketData.ethDominance ?? 10.7)}
            otherPercent={Number(marketData.otherDominance ?? 29.9)}
          />
        </li>

        <li>
          <MarketSecondCap
            currentValue={Number(marketData.btcDominance ?? 30)}
            maxValue={100}
          />
        </li>

        <li>
          <AverageCrypto
            value={averageCryptoRSI}
            formattedValue={formattedAverageCryptoRSI}
            isLoading={isAverageCryptoRSILoading}
          />
        </li>
      </ul>
    </div>
  );
};

export default Cards;